import * as React from 'react';
export var headingSectionIntroFirstContext = React.createContext(false);
